import React from "react";
import { AUTH_TOKEN, SELECTED_ORGANIZATION } from "utils/constants";
import { commitMutation, QueryRenderer as QR } from "react-relay";
import {
  Environment,
  Network,
  RecordSource,
  Store,
  fetchQuery as fQ,
} from "relay-runtime";
import {
  decodeReadStringifyObj,
  generateRedirectAppUrl,
  isEmpty,
  setLocalStorage,
} from "./utils";
import { logout, refreshAccessToken } from "api/client";
import Loader from "./Loader";

const handlerProvider = null;
const source = new RecordSource();
const store = new Store(source);

const network = Network.create(function fetchQuery(
  operation: any,
  variables: any,
  cacheConfig: any,
  uploadables: any
) {
  // MIGRATE TO: https://github.com/relay-tools/react-relay-network-modern
  const authToken = JSON.parse(sessionStorage.getItem(AUTH_TOKEN) || "null");
  const selectedOrganisation = decodeReadStringifyObj(SELECTED_ORGANIZATION);
  // let headers: any = { "Content-Type": "application/json" };
  // headers["X-nf-active-org-short-code"] = selectedOrganisation?.group || "";
  // if (authToken) {
  //   // headers["Authorization"] = "Bearer " + authToken;
  // }

  const headers: Record<string, string> = {
    "X-nf-active-org-short-code": selectedOrganisation?.group || "",
  };

  let body: string | FormData;

  if (uploadables) {
    const formData = new FormData();

    formData.append(
      "operations",
      JSON.stringify({
        query: operation.text,
        variables,
      })
    );

    const map: Record<string, string[]> = {};

    Object.keys(uploadables).forEach((key, index) => {
      map[index] = ["variables.input.file"];
    });

    formData.append("map", JSON.stringify(map));

    Object.keys(uploadables).forEach((key, index) => {
      formData.append(index.toString(), uploadables[key]);
    });

    body = formData;
  } else {
    headers["Content-Type"] = "application/json";

    body = JSON.stringify({
      query: operation.text,
      variables,
    });
  }

  return fetch(`${process.env.REACT_APP_API_URL}/graphql`, {
    method: "POST",
    headers: headers,
    body: body,
    credentials: "include",
  })
    .then(async (response) => {
      const text = await response.text();
      let data: any = null;

      try {
        data = text ? JSON.parse(text) : null;
      } catch {
        data = null;
      }

      const errors = data?.errors;
      if (!isEmpty(errors)) {
        const unauthorized = errors?.some(
          (err: any) =>
            err.extensions?.code === "UNAUTHENTICATED" ||
            err.message?.includes("token") ||
            err.message?.includes("expired") ||
            err.message?.includes("unauthorized") ||
            err.message?.includes(
              "Authentication credentials were not provided"
            )
        );
        if (unauthorized) {
          // window.localStorage.clear();
          // window.sessionStorage.removeItem(AUTH_TOKEN);
          // setLocalStorage("error", "Signature has expired");
          // window.location.replace(generateRedirectAppUrl("home"));
          logout();
        }
      }

      if (data?.data === null) {
        data.data = {
          [operation.name]: null,
        };
      }

      return data;
    })
    .catch((error) => {
      console.error(`Relay request failed for ${operation?.name}`, error);
      throw error;
    });
});

const environment = new Environment({
  handlerProvider,
  network,
  store,
});

function mutateBase(props: any) {
  const onCompleted = (response: any, errors: any) => {
    if (errors && errors.length > 0) {
      var messages: string[] = [];
      errors.forEach((err: any) => {
        messages.push(err.message);
      });
      if (props.onFailure) {
        return props.onFailure(messages);
      } else {
        return alert(messages.join("; "));
      }
    }
    return props.onSuccess(response);
  };
  return commitMutation(environment, {
    mutation: props.mutation,
    variables: props.variables,
    uploadables: props.uploadables,
    onCompleted: onCompleted,
  });
}

function mutate(props: any) {
  // console.log("props", props);
  const variables = { input: props.input };
  return mutateBase({
    mutation: props.mutation,
    variables: variables,
    uploadables: props.uploadables,
    onSuccess: props.onSuccess,
    onFailure: props.onFailure,
  });
}

function QueryRenderer(_props: any) {
  const component = (
    <QR
      environment={environment}
      render={({ error, props }: { error: any; props: any }) => {
        if (error) {
          return <div> {error.message} </div>;
        }
        if (props && Object.keys(props).length > 0) {
          return _props.onSuccess(props);
        }
        if (_props.isTable) {
          return (
            <tr>
              <td>Loading...</td>
            </tr>
          );
        }
        if (_props.isSelect) {
          return <option>Loading...</option>;
        } else {
          return <Loader />;
        }
      }}
      {..._props}
    />
  );
  return component;
}

function fetchQuery(query: any, variables = {}) {
  return fQ(environment, query, variables);
}

export { QueryRenderer, mutate, fetchQuery, environment, mutateBase };
